import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-available',
  templateUrl: './icon-available.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconAvailableComponent {}
